<script>
export default {
    name: "IconRubleLayers"
}
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" fill="none">
        <path
            d="M36.6666 29.3333L22.9025 36.4385C22.6086 36.5887 22.2892 36.6666 21.9661 36.6666C21.643 36.6666 21.3237 36.5887 21.0297 36.4385L7.33331 29.3333"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path
            d="M11.9166 19.25L7.33331 22L21.0297 29.1053C21.3237 29.2555 21.643 29.3333 21.9661 29.3333C22.2892 29.3333 22.6086 29.2555 22.9025 29.1053L36.6666 22L32.0833 19.25"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path
            d="M20.9705 19.2499V21.9999M20.9705 19.2499H18.3333M20.9705 19.2499H26.1582M20.9705 19.2499V15.4654M20.9705 15.4654V7.33325H25.4286C26.6048 7.33325 27.718 7.86508 28.4571 8.78012V8.78012C29.5243 10.1015 29.6117 11.9623 28.6729 13.3779L28.475 13.6762C27.734 14.7936 26.4823 15.4654 25.1415 15.4654H20.9705ZM20.9705 15.4654H18.3333"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
